<div #map style="width:100%;height:100%" click="whero()">
</div>


<script
      src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDyoqsIPcqpYk2a4v9cYewtBsNN1AAUsr8&callback=initMap&libraries=&v=weekly"
      async
    ></script>